import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { sectorslist } from 'src/app/shared/services/sectors.service';
import { statuslist, StatusService } from 'src/app/shared/services/status.service';
import { Region, RegionsService } from 'src/app/shared/services/regions.service';
import { Opportunities ,OpportunityDataRow } from '../../../../services/opportunitiesPage/opportunities';
import { AttachmentService, FileAttachment } from 'src/app/shared/services/attachment.service';
import { OpportunitiesDTO } from 'src/app/services/opportunitiesPage/opportunities-dto';
import { OpportunitiesService } from '../../../../services/opportunitiesPage/opportunities.service';
import { Router, ActivatedRoute } from  '@angular/router';
import { Message } from 'primeng/api/message';

@Component({
  selector: 'close-opportunity',
  templateUrl: './close-opportunity.component.html',
  styleUrls: ['./close-opportunity.component.scss']
})
export class CloseOpportunityComponent implements OnInit {

  //@Input("editOpportunityRow") editOpportunityRow : OpportunityDataRow;
  @Input("statusList") statusList : statuslist[];
  @Input("regionsList") regionsList : Region[];
  @Input("sectors") sectors : sectorslist[];
  loading: boolean = false;

  msgs: Message[] = [];
  public errorMsg;
  attachmentFiles: FileAttachment[] = [];
  //uploadedFiles: any[] = [];
  public updatedOpportunitiesDTO : OpportunitiesDTO = new OpportunitiesDTO(); 
  editOpportunityRow : OpportunityDataRow = new OpportunityDataRow();

  constructor( private attachmentsService : AttachmentService, private opportunitiesService : OpportunitiesService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit() : void {
  }

  public showEditMsg(severity: string, summary: string, detail: string){
    this.msgs = [{severity: severity, summary:summary, detail:detail}];
    setTimeout(()=>{ this.msgs = []}, 3000);
  }

  async onSubmit(event){
    if (!(this.updatedOpportunitiesDTO.status.statusId > 4)){
      this.showMsg('warning', 'Rejected', 'Please select status to close the opportunity!', 4000);
      return;
    }
    if(this.updatedOpportunitiesDTO.status.statusId == 5 && this.attachmentFiles.length==0){//Won status-> force add attachment
      this.showMsg('warning', 'Rejected', 'Please add the related attachments before close the opportunity', 4000);
      return;
    }
    
    this.opportunitiesService.updateOpportunity(this.updatedOpportunitiesDTO).subscribe(
      async response =>{
        ////console.log("update Opportunity : "+ response);
        let opportunityId =  response.data.opportunityId;
        await this.addAttachments(opportunityId);
        this.router.navigate(['/opportunities']);
      },
      error =>{ 
        this.errorMsg = error;
       }
     );
  }

  // async onSubmit(event) {
  //   console.log(this.updatedOpportunitiesDTO.opportunityName+"hello");
  //   if (!(this.updatedOpportunitiesDTO.status.statusId > 4)) {
  //     this.showMsg('warning', 'Rejected', 'Please select status to close the opportunity!', 4000);
  //     return;
  //   }
  //   if (this.updatedOpportunitiesDTO.status.statusId == 5 && this.attachmentFiles.length == 0) { // Won status-> force add attachment
  //     this.showMsg('warning', 'Rejected', 'Please add the related attachments before close the opportunity', 4000);
  //     return;
  //   }


  //   this.opportunitiesService.updateOpportunity(this.updatedOpportunitiesDTO).subscribe(
  //     async response => {
  //       let opportunityId = response.data.opportunityId;
  //       await this.addAttachments(opportunityId);
  //       this.router.navigate(['/opportunities']);
  //       this.loading = false; 
  //     },
  //     error => {
  //       this.errorMsg = error;
  //       this.loading = false; 
  //     }
  //   );
  // }


  async onView(event){
    this.editOpportunityRow = event;
    this.updatedOpportunitiesDTO.opportunityId = this.editOpportunityRow.opportunityId;

    this.opportunitiesService.retrieveOpportunity(this.updatedOpportunitiesDTO.opportunityId ).toPromise().then(
      response =>{
        this.updatedOpportunitiesDTO  = response[0];
        this.updatedOpportunitiesDTO.status.statusId = null;
      },
        error => this.errorMsg = error
    );

    await this.attachmentsService.getAttachments(this.editOpportunityRow.opportunityId).toPromise().then(
      response => {
        this.attachmentFiles = response;
      },
      error => {
        this.errorMsg = error;
        this.showEditMsg('error', 'Rejected', this.errorMsg);
      }
    );    

    //this.showEditMsg('error', 'Rejected', 'Permission already Exists!!!');

  }

onUpload(event,fileUpload) 
  {
    let date = new Date();

    for(let file of event.files) 
    {
      let fileAttachment : FileAttachment = {
        attachmentId : "1",
        attachmentName : file.name,
        content : file,
        contentType : file.type,
        created : (file.lastModifiedDate.getMonth() + 1) + '/' + file.lastModifiedDate.getDate() + '/' +  date.getFullYear(),
        userEmail : sessionStorage.getItem("loginUserName"),
        opportunityAttachment: {opportunityId : this.updatedOpportunitiesDTO.opportunityId}
      };
      this.attachmentFiles.push(fileAttachment); 
    }
    fileUpload.clear();
  }

  deleteAttachment(event)
  {
    for (var kt=0; kt<this.attachmentFiles.length;kt++)
    { 
      let attachmentObj = this.attachmentFiles[kt];

      if (attachmentObj.attachmentId==event.srcElement.id
        && attachmentObj.attachmentName==event.srcElement.title)
      {
        // call delete attachment service Rest API here.....................................................................
        this.attachmentsService.deleteAttachment(this.editOpportunityRow.opportunityId, attachmentObj.attachmentId).subscribe(
          response => {
            this.attachmentFiles.splice(this.attachmentFiles.indexOf(attachmentObj),1);

            event.srcElement.remove();
            var obj = document.getElementById(event.srcElement.id);
            obj.remove();
            this.showMsg('info', 'Confirmed', 'Attachment deleted',2000);  
          },          
          (error) => {
            this.errorMsg = error
            this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!',2000);
          }
        );
        break;
      } 
    }
  }

  downloadAttachment(event){
    ////console.log(event);
    let fileName = event.target.className;
    let fileId = event.target.id;
    for (var kt=0; kt<this.attachmentFiles.length;kt++)
    {
        let attachmentObj = this.attachmentFiles[kt];
        ////console.log(attachmentObj);
        if (attachmentObj.attachmentId == fileId &&   fileName == attachmentObj.attachmentName){
          this.attachmentsService.saveFile(attachmentObj.attachmentName, attachmentObj.contentType, attachmentObj.content);
            break;
        }
    }
  }

  addAttachments(oppId){
    //save attachments to DB
    for(var i=0; i<this.attachmentFiles.length; i++)
    {
      let file = this.attachmentFiles[i];
      ////console.log(file);
      if (file.attachmentId=="1")
      {
        this.attachmentsService.postAttachment(file).subscribe(
          response => {
            ////console.log("Create Attachment Response : "+ response);
            ////console.log(response);
          },
          error => this.errorMsg = error
        );
      }    
    }
  }

  public showMsg(severity: string, summary: string, detail: string, time: number){
    this.msgs = [{severity: severity, summary:summary, detail:detail}];
    setTimeout(()=>{ this.msgs = []}, time);
  }
}
